export default __webpack_public_path__ + "static/media/GS.0674709e.png";